import React, { Dispatch, SetStateAction } from 'react'
import styles from './main.module.scss'
import ReadmeSection from './readmeSection'
import ChangelogSection from './changelog/changeLogSection'
import { parseMarkdown } from '../../utils/markDown'
import VersionDropDown from './dropDown/versionDropDown'
import SourceCodeSnippet from './sourceCodeSnippet'

function Main({
    moduleObject,
    setModuleObject,
    modules,
}: {
    moduleObject: ModuleObject | undefined
    setModuleObject: Dispatch<SetStateAction<ModuleObject | undefined>>
    modules: ModuleObject[]
}) {
    if (!moduleObject || !moduleObject.module || !modules) return null

    const sections = parseMarkdown(moduleObject)

    const sectionsWithoutChangelog = sections.filter(
        (section) => !section.header.toLowerCase().includes('changelog')
    )

    const changelog = sections.filter((section) =>
        section.header.toLowerCase().includes('changelog')
    )[0]

    let moduleVersions = modules.filter(
        (module) => module.module === moduleObject.module
    )

    const isoModule = moduleObject.module.split('/')
    const moduleString = isoModule[isoModule.length - 2]
    const API_URL = `${window.location.hostname}`
    const source =
        'module "' +
        moduleString +
        '" {\n   source = "' +
        API_URL +
        '/' +
        moduleObject.module +
        '\n   version = "' +
        moduleObject.version +
        '"\n}'

    function handleVersionChange(
        e: React.ChangeEvent<HTMLSelectElement>
    ): null {
        const newModule = moduleVersions.find((obj) => {
            return obj.version === e.target.value
        })
        if (newModule) {
            setModuleObject(newModule)
        }
        return null
    }

    return (
        <div className={styles.main}>
            <h1 className={styles.moduleNameHeader}>
                <span className={styles.moduleNameHeaderTitle}>{moduleObject.module}</span>
                <VersionDropDown
                    currentVersion={moduleObject.version}
                    handleVersionChange={handleVersionChange}
                    moduleVersions={moduleVersions}
                />
            </h1>
            <SourceCodeSnippet source={source} />
            {sectionsWithoutChangelog.map((section) => {
                return (
                    <ReadmeSection
                        section={section}
                        key={section.header + moduleObject.version}
                    />
                )
            })}
            {changelog && (
                <ChangelogSection
                    changelog={changelog}
                    key={'changelog' + moduleObject.version}
                />
            )}
        </div>
    )
}

export default Main
